module.exports = __webpack_public_path__ + "static/media/instapage4.dea3fc1c.png";